import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé, connectez-vous.");
      navigate("/connexion");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-[80vh] flex items-center py-20">
      <div className="mx-auto max-w-md w-full px-6">
        <div className="text-center mb-10">
          <div className="h-14 w-14 rounded-2xl bg-[#2196F3] flex items-center justify-center mx-auto mb-6">
            <Lock className="h-7 w-7 text-white" />
          </div>
          <h1 className="font-display text-3xl font-extrabold text-slate-900">Nouveau mot de passe</h1>
          <p className="text-slate-600 mt-2">Choisissez un nouveau mot de passe sécurisé.</p>
        </div>

        <form onSubmit={submit} className="bg-white rounded-3xl border border-slate-100 shadow-sm p-8 space-y-5" data-testid="reset-form">
          {!token && (
            <div className="text-sm text-red-600 bg-red-50 rounded-lg p-3">
              Lien invalide : jeton manquant. Redemandez un lien depuis "Mot de passe oublié".
            </div>
          )}
          <div className="space-y-2">
            <Label htmlFor="npwd">Nouveau mot de passe</Label>
            <Input id="npwd" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="h-12" data-testid="reset-password" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="cpwd">Confirmer</Label>
            <Input id="cpwd" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="h-12" data-testid="reset-confirm" />
          </div>
          <Button type="submit" disabled={loading || !token} className="w-full rounded-full bg-[#2196F3] hover:bg-[#1976D2] h-12" data-testid="reset-submit">
            {loading ? "Enregistrement…" : "Réinitialiser"}
          </Button>
          <div className="text-center text-sm">
            <Link to="/connexion" className="text-[#2196F3] hover:text-[#1976D2] font-semibold">
              <ArrowLeft className="inline mr-1 h-3 w-3" /> Retour à la connexion
            </Link>
          </div>
        </form>
      </div>
    </section>
  );
}
